import * as React from 'react';
import { Typography, ListItem, ListItemText, ListItemIcon, ListItemButton } from '@mui/material';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLowStockExpiringInventoryItems } from '../../../hooks/inventory/useLowStockExpiringInventoryItems';
import InventoryIcon from '@mui/icons-material/Inventory';
import { removeZeroDecimals } from '../../../utils/removeZeroDecimals';
import { useNavigate } from 'react-router-dom';

export default function LowStockExpiringInventoryListItems({ setListEmpty = null, setDoneLoading = null }) {
  const { t } = useTranslation('common');
  const navigate = useNavigate(); 

  const { items, loading, loadMore, searchFunction, resetParent } = useLowStockExpiringInventoryItems(true, 1, 10);

  const handleListItemClick = () => {
    navigate('/inventory'); 
  };

  React.useEffect(() => {
    if (items.data.length !== 0)
    {
      if (setListEmpty) setListEmpty(false);
    }
  }, [items]);

  React.useEffect(() => {
    if (!loading)
    {
      if (setDoneLoading) setDoneLoading(true);
    }
  }, [loading]);

  return (
    <>
      {loading ? (
        <></>
      ) : (
      
      items?.data?.map((item) => (
          <ListItem key={item.id}>
              <ListItemButton onClick={() => handleListItemClick()}>
                  <ListItemIcon>
                      <InventoryIcon fontSize='medium' color='primary' />
                  </ListItemIcon>
                  <ListItemText
                  primary={`${item.name}`}
                  secondary={ 
                  <>
                      <Typography component="span" variant="body2" color={Number(item.current_stock) <= Number(item.low_stock) ? "error" : "text.primary" }>
                      {`${removeZeroDecimals(item.current_stock)}${item.uom} in stock`}
                      </Typography><br />
                      {Number(item.current_stock) <= Number(item.low_stock) ?
                      <>
                      <Typography component="span" variant="body2" color={Number(item.current_stock) <= Number(item.low_stock) ? "error" : "text.primary" } >
                      supplier has been notified
                      </Typography><br />
                      </>
                      : null}
                      <Typography component="span" variant="body2" color="text.secondary">
                      {item.category.name}
                      </Typography>
                      {item.expiry_date ?
                      <>
                      <br />
                      <Typography component="span" variant="body2" color="error">
                      {`Expiry Date: ${item.expiry_date}`}
                      </Typography>
                      </>
                      : null }
                  </>
                    }
                  />
              </ListItemButton>
          </ListItem>
      )))}
      
    </>
  );
}